import { z } from "zod";

import { type AmplitudeEventId } from "../constants";

export function amplitudeEvent<
  T extends z.ZodRawShape,
  I extends AmplitudeEventId,
  C extends string,
  L extends string,
>(args: { id: I; camelCaseName: C; label: L }, schema: T) {
  return {
    ...args,
    schema: z.object(schema),
  };
}
